import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { runningInApp } from '../../services/appConstants/appConstants.js';
import { useInterval } from '../../services/hooks/useInterval.js';
import { useCloseWebView } from '../../services/hooks/useCloseWebView.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/IpcContext.js';
import '../../services/ipcWeb/ipcService.js';
import { useGlobalLogout } from '../../services/logout/useGlobalLogout.js';
import { SessionExpireModal } from './SessionExpireModal.js';

var IdleHandler = function (_a) {
    var timeout = _a.timeout;
    var closeWebView = useCloseWebView().closeWebView;
    var globalLogout = useGlobalLogout().globalLogout;
    var keepAliveInterval = 60 * 1000;
    var promptBeforeIdle = 30 * 1000;
    var _b = useState(timeout), remaining = _b[0], setRemaining = _b[1];
    var _c = useState(false), openPrompt = _c[0], setOpenPrompt = _c[1];
    var autoLogOutDesktop = function () {
        if (!runningInApp) {
            setOpenPrompt(false);
            globalLogout();
        }
    };
    var onActive = function () {
        setOpenPrompt(false);
        if (remaining <= 0 && runningInApp) {
            closeWebView();
        }
    };
    var keepGateWatchAlive = function () {
        fetch('/session/extend', { credentials: 'include' }).catch(function () { return null; });
    };
    useInterval(keepGateWatchAlive, keepAliveInterval);
    var onPrompt = function () {
        setOpenPrompt(true);
    };
    var _d = useIdleTimer({
        onActive: onActive,
        onPrompt: onPrompt,
        timeout: timeout,
        onIdle: autoLogOutDesktop,
        promptBeforeIdle: promptBeforeIdle,
        debounce: 500,
    }), getRemainingTime = _d.getRemainingTime, activate = _d.activate;
    var keepAlive = function () {
        activate();
        setOpenPrompt(false);
    };
    useEffect(function () {
        var interval = setInterval(function () {
            setRemaining(Math.ceil(getRemainingTime() / 1000));
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, []);
    return React.createElement(SessionExpireModal, { visible: openPrompt, keepAlive: keepAlive, remaining: remaining });
};

export { IdleHandler };
